import React, { useEffect, useState } from "react"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import Button from "@/ui/components/Button"
import * as TrinityAPI from "@/requests/TrinityAPI"
import { ICurrencyReplenishmentDto } from "@/types/replenishment/ICurrencyReplenishmentDto"
import { spacedNum } from "@/components/common/CommonHelper"

export const ContractorTab: React.FC<{
  replenishment: ICurrencyReplenishmentDto
  setReplenishment: (r: ICurrencyReplenishmentDto) => void
  errorModel: IErrorModel | undefined
  sending: boolean
  submit: () => void
}> = ({ replenishment, setReplenishment, sending, submit }) => {
  const { currencyRequest } = replenishment

  const [payerCompanyName, setPayerCompanyName] = useState<string>(currencyRequest?.company?.name || "")

  const getBankData = () => {
    const bankInfo = currencyRequest?.company?.banksRef?.find(
      b => String(b.id) === String(currencyRequest?.companyBankId)
    )

    return bankInfo || null
  }

  useEffect(() => {
    if (replenishment.clientCurrencyRequestId) {
      TrinityAPI.getClientCurrencyRequest(Number(replenishment.clientCurrencyRequestId), response => {
        if (response.status === 200) {
          setPayerCompanyName(response.data.company?.name || "")
        }
      })
    }
  }, [replenishment])

  return (
    <>
      <div className="container">
        <div className="container-pop-up">
          <div className="container-pop-up">
            <ul className="form-left">
              <li className="form-block-popup">
                <h4 className="heading-chapter">Данные по валютному плательщику</h4>
                <fieldset>
                  <legend>Название плательщика</legend>
                  <p className="text-form">{currencyRequest?.currencyPayerName || "-"}</p>
                </fieldset>
                <fieldset>
                  <legend>Страна плательщика</legend>
                  <p className="text-form">{currencyRequest?.currencyPayerBankCountry?.fullName || "-"}</p>
                </fieldset>
                <fieldset>
                  <legend>Адрес плательщика</legend>
                  <p className="text-form">{currencyRequest?.currencyPayer?.address || "-"}</p>
                </fieldset>
              </li>

              <li className="form-block-popup">
                <h4 className="heading-chapter">Сумма и валюта оплаты</h4>
                <div className="flex-row-10 flex-wrap-mobile">
                  <fieldset>
                    <legend>Сумма</legend>
                    <p className="text-form">
                      {currencyRequest?.invoicePrice ? spacedNum(Number(currencyRequest.invoicePrice) / 100) : "-"}
                    </p>
                  </fieldset>
                  <fieldset>
                    <legend>Валюта</legend>
                    <p className="text-form">{currencyRequest?.currency || "-"}</p>
                  </fieldset>
                </div>
              </li>
            </ul>

            <div className="right-form">
              <div className="form-block-popup">
                <h4 className="heading-chapter">Данные по зарубежной компании</h4>
                <fieldset>
                  <legend>Название компании</legend>
                  <p className="text-form">{payerCompanyName || "-"}</p>
                </fieldset>
                <fieldset>
                  <legend>Название банка</legend>
                  <p className="text-form">{getBankData()?.name || "-"}</p>
                </fieldset>
                <fieldset>
                  <legend>SWIFT</legend>
                  <p className="text-form">{getBankData()?.swift || "-"}</p>
                </fieldset>
                <fieldset>
                  <legend>Расчетный счет</legend>
                  <p className="text-form">{getBankData()?.accountNumber || "-"}</p>
                </fieldset>
                <fieldset>
                  <legend>Валюта</legend>
                  <p className="text-form">{getBankData()?.currency || "-"}</p>
                </fieldset>
              </div>
            </div>
          </div>
          <div className="flex-row-10">
            {replenishment.status !== "DONE" && (
              <Button loading={sending} onClick={submit}>
                Далее
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
